import { connect } from 'react-redux';
import * as R from 'ramda';

import {
  getItem,
  setActiveLocation,
  setActiveTab,
  setMobileDrawerOpen,
} from '../../store/rackWaitTimesSlice';

import Selector from './Selector';

const mapState = R.applySpec({
  activeLocation: getItem('activeLocation'),
});

const mapDispatchToProps = { setActiveLocation, setActiveTab, setMobileDrawerOpen };

export default connect(mapState, mapDispatchToProps)(Selector);
